import { render, staticRenderFns } from "./selectMessageUser.vue?vue&type=template&id=3fb7661b&scoped=true&"
import script from "./selectMessageUser.vue?vue&type=script&lang=js&"
export * from "./selectMessageUser.vue?vue&type=script&lang=js&"
import style0 from "./selectMessageUser.vue?vue&type=style&index=0&id=3fb7661b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7661b",
  null
  
)

export default component.exports